import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Descriptions, Row, Col, Spin } from 'antd'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { withTranslation } from 'react-i18next'

@inject('emailListStore')
@observer
class FormModal extends Component {
  state = {
  }
  componentDidMount() {
  }

  render() {
    const { emailListStore, addModalVisible, handleCancel } = this.props
    const { sendStatistics } = emailListStore

    return (
      <>
        <Modal
          title='发送统计报告'
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'60%'}
          centered
          footer={false}
        >
          <div className='is-always-shadow'>
            {/* <div className='el-card__header'>任务信息</div> */}
            <Descriptions column={2}>
              <Descriptions.Item label="数仓提交数量">{sendStatistics?.importTotal}</Descriptions.Item>
              <Descriptions.Item label="运营商过滤后数量 ">{sendStatistics?.sendQtyRemak}</Descriptions.Item>
              <Descriptions.Item label="实际发送数量">{sendStatistics?.sendTotal}</Descriptions.Item>
              <Descriptions.Item label="发送成功数量">{sendStatistics?.successSum}</Descriptions.Item>
              <Descriptions.Item label="发送失败数量">{sendStatistics?.failedSum}</Descriptions.Item>
            </Descriptions>
            <div className='tips_box' style={{ paddingLeft: '0px' }}>
              <div className='f_red'><ExclamationCircleFilled /> 各项说明:</div>
              <div><span style={{ fontWeight: 'bold' }}>1、数仓提交数量:</span> 由数仓资源池选中后剔除空值，黑名单、重复的邮箱总数</div>
              <div><span style={{ fontWeight: 'bold' }}>2、运营商过滤后数量:</span> 由运营商发送邮件前过滤的数量，其中包含</div>
              <ul style={{ padding: '0px 0px 0px 20px', margin: '0px' }}>
                <li>格式错误： 邮件地址格式错误</li>
                <li>无效地址： 被群发平台无效地址库命中</li>
                <li>投诉地址： 被群发平台投诉地址库命中</li>
                <li>收件人黑名单：被群发平台添加的收件人黑名单命中</li>
                <li>垃圾拒绝发送: 被收件人服务器判为垃圾邮件的比例过高，导致平台拒绝继续投递此邮件</li>
                <li>收件人黑名单：被群发平台添加的收件人黑名单命中</li>
              </ul>
              <div><span style={{ fontWeight: 'bold' }}>3、实际发送数量：</span>实际投递邮件的总数量</div>
              <div><span style={{ fontWeight: 'bold' }}>4、发送成功数量：</span>实际发送邮件成功的总数量</div>
              <div><span style={{ fontWeight: 'bold' }}>5、发送失败数量：</span>投递过程中出现异常的数量，其中包括</div>
             <ul style={{ padding: '0px 0px 0px 20px', margin: '0px' }}>
                <li>连接异常: 未连接上收件人服务器或连接后异常断开。大部分原因是由于收件人地址错误找不到域名有效MX记录， 或收件人服务器异常</li>
                <li>邮箱不存在: 收件人服务器反馈邮箱不存在，拒绝接收</li>
                <li>空间不足: 收件人服务器反馈邮箱空间不足，拒绝接收</li>
                <li>垃圾内容: 收件人服务器反馈垃圾邮件，拒绝接收</li>
              </ul>
            </div>
          </div>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
